var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }

/*
  This Controller library is concerned with timer-based functions that are
  kicked off periodicially. These functions maintain connections and state
  of the IPFS node.
*/
var DEFAULT_COORDINATION_ROOM = 'psf-ipfs-coordination-002';

var _this;

var TimerControllers = /*#__PURE__*/function () {
  "use strict";

  function TimerControllers() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, TimerControllers);

    // Dependency Injection
    this.adapters = localConfig.adapters;

    if (!this.adapters) {
      throw new Error('Instance of adapters required when instantiating Timer Controllers');
    }

    this.statusLog = localConfig.statusLog;

    if (!this.statusLog) {
      throw new Error('Handler for status logs required when instantiating Timer Controllers');
    }

    this.debugLevel = localConfig.debugLevel;
    this.config = localConfig;
    _this = this;
  }

  _createClass(TimerControllers, [{
    key: "startTimers",
    value: function startTimers(thisNode, useCases) {
      // Periodically maintain the connection to Circuit Relays.
      this.circuitRelayTimerHandle = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.manageCircuitRelays(thisNode, useCases);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })), 60000); // One Minute
      // Periodically announce this nodes existance to the network.

      this.announceTimerHandle = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.manageAnnouncement(thisNode, useCases);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })), 31000); // Periodically maintain the connection to other coordination peers.

      this.peerTimerHandle = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.managePeers(thisNode, useCases);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })), 2 * 50000); // Periodically try to connect to problematic peers that advertise as
      // potential circuit relays.

      this.relaySearch = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this.searchForRelays(thisNode, useCases);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })), 3 * 60000); // Periodically ensure we are disconnected from blacklisted peers.

      this.checkBlacklist = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this.blacklist(thisNode, useCases);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })), 30000);
      this.bwTimerHandle = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var ipfs, pubsubChans;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // monitorBandwidth() throws an error in browsers.
                // if (_this.config.type !== 'browser') {
                //   await _this.monitorBandwidth(thisNode, useCases)
                // }
                // console.log('_this.adapters.ipfs: ', _this.adapters.ipfs)
                ipfs = _this.adapters.ipfs.ipfs;
                _context6.next = 3;
                return ipfs.pubsub.ls();

              case 3:
                pubsubChans = _context6.sent;
                console.log("subscribed pubsub channels: ".concat(JSON.stringify(pubsubChans, null, 2)));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      })), 32000); // Return handles to the different timers.

      return {
        circuitRelayTimerHandle: this.circuitRelayTimerHandle,
        announceTimerHandle: this.announceTimerHandle,
        peerTimerHandle: this.peerTimerHandle,
        relaySearch: this.relaySearch,
        checkBlacklist: this.checkBlacklist
      };
    } // Used mostly for testing. Ensures all timers are stopped.

  }, {
    key: "stopAllTimers",
    value: function () {
      var _stopAllTimers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                clearInterval(this.circuitRelayTimerHandle);
                clearInterval(this.announceTimerHandle);
                clearInterval(this.peerTimerHandle);
                clearInterval(this.relaySearch);
                clearInterval(this.checkBlacklist);
                clearInterval(this.bwTimerHandle);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function stopAllTimers() {
        return _stopAllTimers.apply(this, arguments);
      }

      return stopAllTimers;
    }() // Monitor the bandwidth being consumed by IPFS peers. Disconnect from peers
    // that request too much bandwidth.

  }, {
    key: "monitorBandwidth",
    value: function () {
      var _monitorBandwidth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(thisNode, useCases) {
        var ipfs, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, stats, bitswap, pubsubs, MAX_PEERS;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                ipfs = this.adapters.ipfs.ipfs; // const bw = await ipfs.stats.bw()
                // console.log('bw: ', bw)

                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context8.prev = 4;
                _iterator = _asyncIterator(ipfs.stats.bw());

              case 6:
                _context8.next = 8;
                return _iterator.next();

              case 8:
                if (!(_iteratorAbruptCompletion = !(_step = _context8.sent).done)) {
                  _context8.next = 14;
                  break;
                }

                stats = _step.value;
                // console.log(stats)
                this.adapters.log.statusLog(2, 'Bandwidth stats: ', stats); // this.adapters.log.statusLog(2, `${JSON.stringify(stats, null, 2)}`)

              case 11:
                _iteratorAbruptCompletion = false;
                _context8.next = 6;
                break;

              case 14:
                _context8.next = 20;
                break;

              case 16:
                _context8.prev = 16;
                _context8.t0 = _context8["catch"](4);
                _didIteratorError = true;
                _iteratorError = _context8.t0;

              case 20:
                _context8.prev = 20;
                _context8.prev = 21;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context8.next = 25;
                  break;
                }

                _context8.next = 25;
                return _iterator.return();

              case 25:
                _context8.prev = 25;

                if (!_didIteratorError) {
                  _context8.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context8.finish(25);

              case 29:
                return _context8.finish(20);

              case 30:
                _context8.next = 32;
                return ipfs.stats.bitswap();

              case 32:
                bitswap = _context8.sent;
                this.adapters.log.statusLog(2, 'bitswap stats: ', bitswap); // this.adapters.log.statusLog(2, `${JSON.stringify(bitswap, null, 2)}`)
                // Monitor pubsub channels.

                _context8.next = 36;
                return ipfs.pubsub.ls();

              case 36:
                pubsubs = _context8.sent;
                // this.adapters.log.statusLog(2, 'pubsubs: ', pubsubs)
                this.adapters.log.statusLog(2, "pubsubs: ".concat(JSON.stringify(pubsubs, null, 2))); // Shut down node if it runs-away with connections.

                MAX_PEERS = 50;

                if (!(bitswap.peers.length > MAX_PEERS)) {
                  _context8.next = 47;
                  break;
                }

                console.log("IPFS node is misbehaving, by connecting to more than ".concat(MAX_PEERS, " peers. Shutting down for 10 seconds."));
                _context8.next = 43;
                return ipfs.stop();

              case 43:
                _context8.next = 45;
                return sleep(10000);

              case 45:
                _context8.next = 47;
                return ipfs.start();

              case 47:
                _context8.next = 53;
                break;

              case 49:
                _context8.prev = 49;
                _context8.t1 = _context8["catch"](0);
                console.error('Error in timer-controller.js/monitorBandwidth(): ', _context8.t1);
                this.adapters.log.statusLog(2, 'Error in timer-controller.jsmonitorBandwidth(): ', _context8.t1); // Note: Do not throw an error. This is a top-level function.

              case 53:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 49], [4, 16, 20, 30], [21,, 25, 29]]);
      }));

      function monitorBandwidth(_x, _x2) {
        return _monitorBandwidth.apply(this, arguments);
      }

      return monitorBandwidth;
    }() // This function is intended to be called periodically by setInterval().

  }, {
    key: "manageCircuitRelays",
    value: function () {
      var _manageCircuitRelays = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(thisNode, useCases) {
        var now;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                console.log('Entering manageCircuitRelays() Controller.'); // Disable the timer while processing is happening.

                clearInterval(this.circuitRelayTimerHandle); // Remove any duplicate entries

                useCases.relays.removeDuplicates(thisNode); // Maintain connections to Relays.

                _context10.next = 6;
                return useCases.relays.connectToCRs(thisNode);

              case 6:
                _context10.next = 8;
                return useCases.relays.measureRelays(thisNode);

              case 8:
                now = new Date();
                this.adapters.log.statusLog(1, "Renewed connections to all circuit relays at ".concat(now.toLocaleString())); // console.log('Exiting manageCircuitRelays() Controller.')

                _context10.next = 16;
                break;

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10["catch"](0);
                console.error('Error in timer-controller.js/manageCircuitRelays(): ', _context10.t0);
                this.adapters.log.statusLog(2, 'Error in timer-controller.js/manageCircuitRelays(): ', _context10.t0); // Note: Do not throw an error. This is a top-level function.

              case 16:
                // Periodically maintain the connection to Circuit Relays.
                this.circuitRelayTimerHandle = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return _this.manageCircuitRelays(thisNode, useCases);

                        case 2:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                })), 60000); // One Minute

              case 17:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 12]]);
      }));

      function manageCircuitRelays(_x3, _x4) {
        return _manageCircuitRelays.apply(this, arguments);
      }

      return manageCircuitRelays;
    }() // This function is intended to be called periodically by setInterval().
    // Announce the existance of this node to the network.

  }, {
    key: "manageAnnouncement",
    value: function () {
      var _manageAnnouncement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(thisNode, useCases) {
        var announceObj, announceMsgObj, announceMsgStr, now;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                // console.log('thisNode: ', thisNode)
                // Get the information needed for the announcement.
                announceObj = {
                  ipfsId: thisNode.ipfsId,
                  ipfsMultiaddrs: thisNode.ipfsMultiaddrs,
                  type: thisNode.type,
                  // orbitdbId: thisNode.orbit.id,
                  // TODO: Allow node.js apps to pass a config setting to override this.
                  isCircuitRelay: false
                }; // Generate the announcement message.

                announceMsgObj = thisNode.schema.announcement(announceObj); // console.log(`announceMsgObj: ${JSON.stringify(announceMsgObj, null, 2)}`)

                announceMsgStr = JSON.stringify(announceMsgObj); // Publish the announcement to the pubsub channel.

                _context11.next = 6;
                return this.adapters.pubsub.messaging.publishToPubsubChannel(DEFAULT_COORDINATION_ROOM, announceMsgStr);

              case 6:
                if (this.debugLevel) {
                  now = new Date();
                  this.statusLog("status: Announced self on ".concat(DEFAULT_COORDINATION_ROOM, " pubsub channel at ").concat(now.toLocaleString()));
                }

                return _context11.abrupt("return", true);

              case 10:
                _context11.prev = 10;
                _context11.t0 = _context11["catch"](0);
                console.error('Error in timer-controller.js/manageAnnouncement(): ', _context11.t0);
                this.adapters.log.statusLog(2, 'Error in timer-controller.js/manageAnnouncement(): ', _context11.t0); // Note: Do not throw an error. This is a top-level function.

              case 14:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 10]]);
      }));

      function manageAnnouncement(_x5, _x6) {
        return _manageAnnouncement.apply(this, arguments);
      }

      return manageAnnouncement;
    }() // This function is intended to be called periodically by setInterval().
    // It refreshes the connection to all subnet peers thisNode is trying to track.

  }, {
    key: "managePeers",
    value: function () {
      var _managePeers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(thisNode, useCases) {
        var success;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                success = false;
                _context13.prev = 1;
                // Disable the timer while processing is happening.
                clearInterval(this.peerTimerHandle); // this.statusLog('managePeers')

                _context13.next = 5;
                return useCases.thisNode.refreshPeerConnections();

              case 5:
                // console.error('Error in timer-controller.js/manageAnnouncement(): ', err)
                this.adapters.log.statusLog(1, 'Renewed connections to all subnet peers.');
                success = true;
                _context13.next = 13;
                break;

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13["catch"](1);
                this.adapters.log.statusLog(2, 'Error in timer-controller.js/managePeers(): ', _context13.t0); // Note: Do not throw an error. This is a top-level function.

                success = false;

              case 13:
                // Reinstate the timer interval
                this.peerTimerHandle = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
                  return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                      switch (_context12.prev = _context12.next) {
                        case 0:
                          _context12.next = 2;
                          return _this.managePeers(thisNode, useCases);

                        case 2:
                        case "end":
                          return _context12.stop();
                      }
                    }
                  }, _callee12);
                })), 21000);
                return _context13.abrupt("return", success);

              case 15:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[1, 9]]);
      }));

      function managePeers(_x7, _x8) {
        return _managePeers.apply(this, arguments);
      }

      return managePeers;
    }() // Actively disconnect from blacklisted peers.

  }, {
    key: "blacklist",
    value: function () {
      var _blacklist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(thisNode, useCases) {
        var success;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                success = false;
                _context15.prev = 1;
                // Disable the timer while processing is happening.
                clearInterval(this.checkBlacklist); // this.statusLog('managePeers')
                // await useCases.thisNode.enforceBlacklist()

                _context15.next = 5;
                return useCases.thisNode.enforceWhitelist();

              case 5:
                this.adapters.log.statusLog(1, 'Finished enforcing whitelist.');
                success = true;
                _context15.next = 13;
                break;

              case 9:
                _context15.prev = 9;
                _context15.t0 = _context15["catch"](1);
                this.adapters.log.statusLog(2, 'Error in timer-controller.js/blacklist(): ', _context15.t0); // Note: Do not throw an error. This is a top-level function.

                success = false;

              case 13:
                // Reinstate the timer interval
                this.checkBlacklist = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
                  return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                      switch (_context14.prev = _context14.next) {
                        case 0:
                          _context14.next = 2;
                          return _this.blacklist(thisNode, useCases);

                        case 2:
                        case "end":
                          return _context14.stop();
                      }
                    }
                  }, _callee14);
                })), 30000);
                return _context15.abrupt("return", success);

              case 15:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[1, 9]]);
      }));

      function blacklist(_x9, _x10) {
        return _blacklist.apply(this, arguments);
      }

      return blacklist;
    }() // This method looks for subnet peers that have the isCircuitRelay flag set,
    // but are not in the list of known relays. These represent potential relays
    // that thisNode could not connect to, but it might be able to with another
    // try.

  }, {
    key: "searchForRelays",
    value: function () {
      var _searchForRelays = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(thisNode, useCases) {
        var knownRelays, relayPeers, diffRelayPeers, i, thisPeer;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                // console.log('Entering searchForRelays() Controller.')
                // Disable the timer while processing is happening.
                clearInterval(this.relaySearch); // Get all the known relays.

                knownRelays = thisNode.relayData.map(function (x) {
                  return x.ipfsId;
                }); // console.log('knownRelays: ', knownRelays)
                // Get all subnet peers that have their circuit relay flag set.

                relayPeers = thisNode.peerData.filter(function (x) {
                  return x.data.isCircuitRelay;
                });
                relayPeers = relayPeers.map(function (x) {
                  return x.from;
                }); // console.log('relayPeers: ', relayPeers)
                // Diff the two arrays to get relays peers that are not in the relay list.

                diffRelayPeers = relayPeers.filter(function (x) {
                  return !knownRelays.includes(x);
                }); // console.log('diffRelayPeers: ', diffRelayPeers)
                // Try to connect to each potential relay.

                i = 0;

              case 7:
                if (!(i < diffRelayPeers.length)) {
                  _context17.next = 14;
                  break;
                }

                thisPeer = diffRelayPeers[i];
                _context17.next = 11;
                return useCases.relays.addRelay(thisPeer, thisNode);

              case 11:
                i++;
                _context17.next = 7;
                break;

              case 14:
                _context17.next = 19;
                break;

              case 16:
                _context17.prev = 16;
                _context17.t0 = _context17["catch"](0);
                // console.error('Error in timer-controller.js/searchForRelays(): ', err)
                this.adapters.log.statusLog(2, 'Error in timer-controller.js/searchForRelays(): ', _context17.t0); // Note: Do not throw an error. This is a top-level function.

              case 19:
                // Periodically try to connect to problematic peers that advertise as
                // potential circuit relays.
                this.relaySearch = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
                  return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                      switch (_context16.prev = _context16.next) {
                        case 0:
                          _context16.next = 2;
                          return _this.searchForRelays(thisNode, useCases);

                        case 2:
                        case "end":
                          return _context16.stop();
                      }
                    }
                  }, _callee16);
                })), 5 * 60000);

              case 20:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[0, 16]]);
      }));

      function searchForRelays(_x11, _x12) {
        return _searchForRelays.apply(this, arguments);
      }

      return searchForRelays;
    }()
  }]);

  return TimerControllers;
}();

function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

module.exports = TimerControllers;